import React from 'react';
import { RouteComponentProps } from 'react-router';
import { ScrollToTop } from '../components/scroll_to_top/scroll_to_top';
import { TournamentDetailContainer } from '../components/tournament_detail/tournament_detail_container';

export const TournamentDetailPage = (props: RouteComponentProps<{ slug: string }>) => {
  return (
    <ScrollToTop>
      <section
        style={{
          paddingBottom: '144px',
        }}
      >
        <TournamentDetailContainer slug={props.match.params.slug} />
      </section>
    </ScrollToTop>
  );
};
export default TournamentDetailPage;
